/**
 * @fileoverview Single source of truth for reading Vite environment variables.
 * @description Reads import.meta.env exactly once and exposes a typed, parsed env object. Every
 * other module reads values from here instead of touching import.meta.env directly, so the base
 * API URL and other environment-driven settings each live in exactly one place.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  appName: import.meta.env.VITE_APP_NAME,
  isDevServer: import.meta.env.DEV,
  apiBaseUrl: import.meta.env.VITE_API_URL,
  enableMockApi: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
  disableRightClick: import.meta.env.VITE_DISABLE_RIGHT_CLICK === 'true',
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID,
  firebaseMeasurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  firebaseVapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
}
